import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { adminGetMyAccess } from "@/lib/admin-authz.functions";
import type { AdminSection } from "@/lib/admin-authz";

export type AuthedAccess = { roles: string[]; sections: AdminSection[] };

export const Route = createFileRoute("/_authenticated")({
  ssr: false,
  // Block every protected render until BOTH the session and the current role
  // set are confirmed. `beforeLoad` runs before any child loader or component,
  // so /account, /admin, and any orders pages never see a half-resolved user.
  beforeLoad: async () => {
    const { data, error } = await supabase.auth.getUser();
    if (error || !data.user) {
      throw redirect({ to: "/auth" });
    }
    let access: AuthedAccess = { roles: [], sections: [] };
    try {
      access = (await adminGetMyAccess()) as AuthedAccess;
    } catch {
      // Non-admin users get an empty role set; still allowed into /account.
      access = { roles: [], sections: [] };
    }
    return { user: data.user, access };
  },
  component: () => <Outlet />,
});
